module.exports = __webpack_public_path__ + "img/translator__en-ru.9066358.svg";